import React from "react";
import Nav from "./components/Nav";
import Hero from "./components/Hero";
import HowItWorks from "./components/HowItWorks";
import Benefits from "./components/Benefits";
import CaseStudies from "./components/CaseStudies";
import Footer from "./components/Footer";
import Testimonials from "./components/Testimonials";
import FAQs from "./components/FAQs";
import Services from "./components/Services";
import PricingCallToAction from "./components/PricingCalltoAction";
import Aboutus from "./components/Aboutus";
function Home() {
  return (
    <div>
      <Nav />
      <Hero />
      <Aboutus />
      <Services/>
      <HowItWorks />
      <Benefits />
      <PricingCallToAction />
      <CaseStudies />
      {/* <Testimonials /> */}
      <FAQs />
      <Footer />
    </div>
  );
}

export default Home;
